"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralProgramStatus = void 0;
var ReferralProgramStatus;
(function (ReferralProgramStatus) {
    ReferralProgramStatus["ACTIVE"] = "ACTIVE";
    ReferralProgramStatus["INACTIVE"] = "INACTIVE";
})(ReferralProgramStatus || (exports.ReferralProgramStatus = ReferralProgramStatus = {}));
//# sourceMappingURL=program.js.map